var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack317({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.19,8.89V7.56h3.42V10.7a4.33,4.33,0,0,1-1.45.85,5.37,5.37,0,0,1-1.92.37,4.36,4.36,0,0,1-2.15-.52A3.35,3.35,0,0,1,4.71,9.92a4.81,4.81,0,0,1-.46-2.1,4.6,4.6,0,0,1,.51-2.19A3.55,3.55,0,0,1,6.27,4.17a4.13,4.13,0,0,1,1.89-.4,3.75,3.75,0,0,1,2.29.62,2.79,2.79,0,0,1,1.06,1.7l-1.58.29a1.65,1.65,0,0,0-.63-.91,1.88,1.88,0,0,0-1.14-.34,2.15,2.15,0,0,0-1.66.66,2.79,2.79,0,0,0-.61,2,3.07,3.07,0,0,0,.62,2.11,2.09,2.09,0,0,0,1.63.7,2.7,2.7,0,0,0,1-.2A3.57,3.57,0,0,0,10,9.89v-1Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 8,
    r: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack317);
export default __webpack_public_path__ + "static/media/Symbolpack_3_17.f0998551f80309e14213c0202fba0d7a.svg";
export { ForwardRef as ReactComponent };